const readJson = (key, fallback) => {
  try {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : fallback;
  } catch (error) {
    return fallback;
  }
};

export const getCurrentAdmin = () => readJson("admin_user", null);
export const getAdminMenus = () => readJson("menu", []);
export const isSuperAdmin = () => Number(getCurrentAdmin()?.user_level_id) === 1;

export const canAccessRoute = route => {
  const admin = getCurrentAdmin();
  if (!admin) return true;
  if (Number(admin.user_level_id) === 1) return true;
  return getAdminMenus().some(menu => menu.route === route);
};

export const firstAccessibleRoute = menus => {
  const routes = (menus || []).map(menu => menu.route).filter(Boolean);
  return routes.includes("/dashboard") ? "/dashboard" : routes[0] || "/";
};
